module.exports={
	"Form": "LabEditManifest",
	"Scope": "Lab-Edit",
	"Descriptors":
	{
		"LabDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lab-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Lab-Edit-Identity",
				"Group": "Lab-Edit-Identity"
			}
		},
		"LabDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Lab-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"LabDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "Lab-Edit-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"LabDetails.ExternalOrganization":
		{
			"Name": "External Organization",
			"Hash": "Lab-Edit-ExternalOrganization",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 3,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Lab-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.IDLabParent":
		{
			"Name": "Parent Lab",
			"Hash": "Lab-Edit-IDLabParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"LabDetails.ExternalLabID":
		{
			"Name": "External Lab ID",
			"Hash": "Lab-Edit-ExternalLabID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.BypassReceived":
		{
			"Name": "Bypass Received",
			"Hash": "Lab-Edit-BypassReceived",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.AggregateTo":
		{
			"Name": "Aggregate To",
			"Hash": "Lab-Edit-AggregateTo",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Lab-Edit-Details",
				"Group": "Lab-Edit-Details"
			}
		},
		"LabDetails.IDLab":
		{
			"Name": "IDLab",
			"Hash": "Lab-Edit-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.GUIDLab":
		{
			"Name": "GUIDLab",
			"Hash": "Lab-Edit-GUIDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lab-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lab-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lab-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		},
		"LabDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lab-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Lab-Edit-DataAudit",
				"Group": "Lab-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lab-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lab-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lab-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lab-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lab-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lab-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
